import { createSlice } from '@reduxjs/toolkit';
import Vehicle from '../../core/models/Vehicle';
import { RootState } from './store';
interface AuctionState {
    vehicles: Vehicle[],
}

const initialState: AuctionState = {
    vehicles: [],
}

const auctionSlice = createSlice({
    name: 'auction',
    initialState: initialState,
    reducers: {
        setVehicles: (state, action) => {
            const { vehicles } = action.payload;
            state.vehicles = vehicles;
        },
    },
})

export const { setVehicles } = auctionSlice.actions

export default auctionSlice.reducer

export const getAuctionVehicles = (state: RootState): Vehicle[] | [] => state.auction.vehicles;
